import React, { useState } from 'react';


const NotesCard = ({ notes, setNotes }) => {
  return (
    <div style={styles.infoCard}>
      <div style={styles.cardTitle}>Notes (Optional)</div>
      <textarea
        placeholder="Add any special instructions..."
        value={notes}
        onChange={(e) => setNotes(e.target.value)}
        style={styles.notesInput}
      />
    </div>
  );
};


const styles = {
  infoCard: {
    backgroundColor: "#fff",
    margin: "14px 10px",
    borderRadius: 20,
    padding: 16,
    boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.1)",
  },
  cardTitle: {
    color: "#2E2E2E",
    fontSize: "18px",
    fontWeight: "600",
    marginBottom: "12px",
  },
  notesInput: {
    border: '1px solid #ccc',
    borderRadius: 8,
    padding: '12px',
    fontSize: 14,
    fontWeight: "500",
    // letterSpacing: 1,
    marginTop: 6,
    width: '100%',
    color: '#000',
    outline: 'none',
  },
};

export default NotesCard;
